import { FC, useEffect } from 'react';

import { NotificationPageView } from './NotificationPageView';
import { useListStore, useQueryString } from './hooks';

export const NotificationPage: FC = () => {
  const { page } = useQueryString();
  const { finalUpdateTime, fetchNotifications } = useListStore();

  useEffect(() => {
    void fetchNotifications(page);
  }, [page, finalUpdateTime, fetchNotifications]);

  return <NotificationPageView />;
};
